module.exports = __webpack_public_path__ + "static/media/3.377403e7.svg";